<template>
  <div id="app" class="bralife" :data-version="version">
    <Header />
    <router-view :class="this.lightbox.show && 'blur'" />
    <a
      v-if="dontShowWhatsApp.indexOf(this.$route.path) < 0"
      class="bralife__whatsapp" :href="`https://api.whatsapp.com/send?phone=+552122833115&text=${encodeWhatsAppMessage}`" target="_blank" rel="noreferrer noopener">link para mensagem no WhatsApp</a>
    <Footer/>
    <Lightbox />
  </div>
</template>

<script>
import { version } from '../package.json';
import Header from "./components/layouts/Header";
import Footer from "./components/layouts/Footer";
import Lightbox from "./components/layouts/Lightbox";
import { mapState } from "vuex";
export default {
  name: "app",
  components: {
    Header,
    Footer,
    Lightbox
  },
  data() {
    return {
      whatsappMessage: "Olá, poderia me ajudar a esclarecer uma dúvida?",
      dontShowWhatsApp: [
        '/sobre-servico',
        '/sobre-beneficios',
        '/sobre-coberturas',
        '/sobre-como-contratar',
        '/termos-e-condicoes'
      ],
      version
    };
  },
  computed: {
    ...mapState(["lightbox"]),
    encodeWhatsAppMessage: function() {
      return encodeURI(this.whatsappMessage);
    }
  }
};
</script>

<style lang="scss">
.bralife {
  position: relative;
  font-family: $font-family__default;
  .blur {
    filter: blur(3px);
  }
  &__whatsapp {
    font-size: 0;
    @include breakpoint($tablet__max--lg) {
      position: fixed;
      bottom: $space__xh;
      right: $space__st;
      width: $space__hg;
      height: $space__hg;
      background-image: url("./assets/img/whats-app-icon.png");
      background-repeat: no-repeat;
      background-size: contain;
      z-index: 4;
    }
  }
}
</style>
